var _linearGradient, _linearGradient2, _linearGradient3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcHomeDiscount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.828,
    height: 36.226,
    viewBox: "0 0 39.828 36.226",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rggd5dkchd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4134",
    d: "M15.072 4.682c.483-.573.941-1.168 1.418-1.747a1.092 1.092 0 0 1 1.824 0c.465.56.913 1.131 1.374 1.693a3.411 3.411 0 0 0 3.73 1.244c.738-.184 1.47-.395 2.207-.584a1.083 1.083 0 0 1 1.43 1.049q.069 1.087.122 2.177a3.432 3.432 0 0 0 2.32 3.249c.7.275 1.4.527 2.1.8a1.2 1.2 0 0 1 .8 1.063 4.678 4.678 0 0 1-.294.659c-.375.607-.774 1.2-1.163 1.8a3.438 3.438 0 0 0-.008 4.021c.386.6.782 1.2 1.168 1.8a1.1 1.1 0 0 1-.565 1.761q-1 .39-2 .768a3.464 3.464 0 0 0-2.368 3.286 86 86 0 0 1-.125 2.212 1.075 1.075 0 0 1-1.379 1.006c-.772-.194-1.536-.418-2.309-.609a3.365 3.365 0 0 0-3.6 1.165c-.495.579-.957 1.186-1.442 1.774a1.1 1.1 0 0 1-1.847 0c-.476-.58-.933-1.176-1.418-1.748a3.376 3.376 0 0 0-3.621-1.185c-.728.177-1.448.388-2.173.577a1.082 1.082 0 0 1-.49.082 1.1 1.1 0 0 1-1.028-1.167c-.061-.9-.062-1.81-.192-2.7a3.24 3.24 0 0 0-2.1-2.612c-.722-.3-1.464-.562-2.195-.847a1.1 1.1 0 0 1-.575-1.731c.4-.632.821-1.254 1.221-1.889a3.4 3.4 0 0 0 .006-3.866c-.387-.616-.793-1.219-1.187-1.829a1.116 1.116 0 0 1 .587-1.823c.7-.269 1.409-.523 2.1-.811a3.388 3.388 0 0 0 2.218-3.137c.047-.76.08-1.522.129-2.282a1.06 1.06 0 0 1 .051-.32 1.073 1.073 0 0 1 1.349-.7c.76.193 1.514.41 2.275.6a3.387 3.387 0 0 0 3.65-1.2m-.351-3.3a76.16 76.16 0 0 0-1.414 1.751 1.2 1.2 0 0 1-1.4.453 49.798 49.798 0 0 0-2.342-.62 3.264 3.264 0 0 0-.326-.056 3.412 3.412 0 0 0-3.807 2.966c-.09.815-.112 1.637-.141 2.457A1.254 1.254 0 0 1 4.384 9.6c-.672.235-1.334.5-2 .762A3.439 3.439 0 0 0 .7 15.55q.6.933 1.209 1.856a1.172 1.172 0 0 1 0 1.409q-.6.907-1.19 1.826a3.438 3.438 0 0 0 1.7 5.228c.655.251 1.3.52 1.968.751a1.244 1.244 0 0 1 .908 1.269c.018.691.051 1.383.095 2.073a3.458 3.458 0 0 0 4.35 3.264 64.85 64.85 0 0 0 2.169-.588 1.2 1.2 0 0 1 1.4.451c.461.592.911 1.2 1.424 1.742a5.946 5.946 0 0 0 1.2.948 4.675 4.675 0 0 0 .979.347h.981a.478.478 0 0 1 .119-.061 3.4 3.4 0 0 0 2.117-1.277c.455-.569.922-1.126 1.368-1.7a1.194 1.194 0 0 1 1.4-.452c.686.2 1.379.369 2.068.558a3.425 3.425 0 0 0 4.418-2.953c.091-.787.1-1.587.133-2.387a1.22 1.22 0 0 1 .871-1.221 66.05 66.05 0 0 0 2.067-.788 3.484 3.484 0 0 0 .727-.371 3.441 3.441 0 0 0 .944-4.775c-.4-.633-.813-1.261-1.228-1.885a1.167 1.167 0 0 1 0-1.408q.629-.935 1.228-1.885a3.443 3.443 0 0 0-1.673-5.145 69.669 69.669 0 0 0-2.067-.787 1.213 1.213 0 0 1-.869-1.222c-.021-.665-.059-1.333-.09-2a3.463 3.463 0 0 0-4.563-3.31c-.666.185-1.335.357-2 .541a1.169 1.169 0 0 1-1.34-.435q-.709-.9-1.438-1.777a3.437 3.437 0 0 0-5.363 0",
    style: {
      fill: "url(#iekhc20d1a)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7qevs4so2e"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5830",
    style: {
      fill: "url(#dgzhaofw9b)"
    },
    d: "M0 0h34.81v36.226H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "oyunxhwfkf"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4136",
    d: "M21.479 12.259q-5.348 5.355-10.7 10.709a1.747 1.747 0 0 0-.188.206 1.162 1.162 0 0 0 .939 1.871 1.3 1.3 0 0 0 .94-.463l8.337-8.339q1.17-1.174 2.344-2.343a1.176 1.176 0 0 0 .412-.843 1.151 1.151 0 0 0-.824-1.175 1.184 1.184 0 0 0-1.259.377",
    style: {
      fill: "url(#vmgx6k8kgc)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uxbw249ffg"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4138",
    d: "M10.31 14.1v.085a2.336 2.336 0 1 0 2.4-2.354h-.066A2.336 2.336 0 0 0 10.31 14.1",
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "km0tfhhmqh"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4140",
    d: "M18.949 22.748a2.326 2.326 0 0 0 2.32 2.333h.02a2.315 2.315 0 0 0 2.311-2.318 2.327 2.327 0 0 0-2.321-2.333h-.006a2.326 2.326 0 0 0-2.326 2.321",
    style: {
      fill: "gray"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "iekhc20d1a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b9b9b"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dgzhaofw9b",
    x1: 0.011,
    y1: 1.003,
    x2: 0.039,
    y2: 1.003,
    xlinkHref: "#iekhc20d1a"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vmgx6k8kgc",
    x1: -0.375,
    y1: -1.935,
    x2: -0.308,
    y2: 1.353,
    xlinkHref: "#iekhc20d1a"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2953"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4142",
    d: "M6.229 0H33.6c3.44 0 6.229 3.134 6.229 7v1c0 3.866-2.789 7-6.229 7H6.229C2.789 15 0 11.866 0 8V7c0-3.866 2.789-7 6.229-7z",
    transform: "translate(0 2.174)",
    style: {
      fill: "#fff4aa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2950"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2934"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2933",
    style: {
      clipPath: "url(#rggd5dkchd)"
    },
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5829",
    transform: "translate(-.376 .095)",
    style: {
      fill: "url(#iekhc20d1a)"
    },
    d: "M0 0h35.559v36.031H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2936"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2935",
    style: {
      clipPath: "url(#7qevs4so2e)"
    },
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4135",
    d: "M17.922 36.226H16.9l-.016-.005c-.1-.034-.2-.063-.306-.091a2.65 2.65 0 0 1-.693-.266 5.99 5.99 0 0 1-1.225-.964 18.694 18.694 0 0 1-1.2-1.457l-.226-.292a1.1 1.1 0 0 0-1.291-.417c-.81.233-1.521.426-2.173.589a3.884 3.884 0 0 1-.936.117 3.471 3.471 0 0 1-2.424-.971 3.787 3.787 0 0 1-1.117-2.5 68.322 68.322 0 0 1-.1-2.077 1.15 1.15 0 0 0-.84-1.177 37.988 37.988 0 0 1-1.434-.542l-.537-.21a3.539 3.539 0 0 1-1.741-5.375c.375-.582.778-1.207 1.19-1.827a1.065 1.065 0 0 0 0-1.3c-.394-.594-.8-1.218-1.209-1.857a3.538 3.538 0 0 1 .921-4.918 3.5 3.5 0 0 1 .813-.414l.481-.188c.5-.195 1.011-.4 1.524-.576a1.15 1.15 0 0 0 .84-1.18l.007-.2c.025-.742.052-1.51.135-2.26a3.526 3.526 0 0 1 3.482-3.083 3.456 3.456 0 0 1 .772.088c.794.183 1.584.406 2.347.621a1.1 1.1 0 0 0 1.291-.418c.463-.594.934-1.168 1.416-1.753a3.537 3.537 0 0 1 5.517 0 97.077 97.077 0 0 1 1.439 1.779 1.069 1.069 0 0 0 1.235.4c.326-.09.658-.179.98-.265s.681-.182 1.02-.276a4.285 4.285 0 0 1 1.143-.16 3.517 3.517 0 0 1 3.546 3.488v.074l.025.5c.025.493.05 1 .065 1.506a1.116 1.116 0 0 0 .8 1.131c.721.259 1.421.532 2.07.788a3.542 3.542 0 0 1 1.721 5.292c-.361.568-.763 1.186-1.229 1.887a1.063 1.063 0 0 0 0 1.3c.484.728.875 1.328 1.229 1.887a3.543 3.543 0 0 1-1.719 5.292c-.567.225-1.314.518-2.07.789a1.124 1.124 0 0 0-.806 1.131l-.016.459a24.308 24.308 0 0 1-.116 1.935 3.615 3.615 0 0 1-1.165 2.3 3.511 3.511 0 0 1-2.34.877 3.922 3.922 0 0 1-1.039-.143c-.28-.077-.565-.152-.841-.225-.4-.106-.82-.216-1.228-.334a1.1 1.1 0 0 0-1.29.418c-.279.359-.57.716-.853 1.062-.17.208-.346.424-.516.637a3.518 3.518 0 0 1-2.177 1.313.205.205 0 0 0-.046.025l-.044.026zm-.993-.2h.942l.011-.007a.316.316 0 0 1 .118-.052 3.327 3.327 0 0 0 2.056-1.241c.171-.214.347-.43.518-.638.281-.345.572-.7.85-1.059a1.274 1.274 0 0 1 1.043-.557 1.678 1.678 0 0 1 .461.07c.406.117.822.226 1.224.332.277.073.562.148.843.225a3.735 3.735 0 0 0 .986.136 3.307 3.307 0 0 0 2.207-.826 3.37 3.37 0 0 0 1.1-2.178c.072-.634.094-1.288.115-1.919 0-.153.011-.307.016-.46a1.319 1.319 0 0 1 .938-1.312c.754-.27 1.5-.562 2.064-.786a3.34 3.34 0 0 0 1.624-5 96.921 96.921 0 0 0-1.226-1.883 1.274 1.274 0 0 1 0-1.519c.466-.7.867-1.316 1.227-1.883a3.343 3.343 0 0 0-1.625-5 68.417 68.417 0 0 0-2.064-.786 1.312 1.312 0 0 1-.937-1.313c-.015-.5-.041-1.01-.065-1.5l-.025-.5A3.325 3.325 0 0 0 26.053 3h-.07a4.1 4.1 0 0 0-1.09.153c-.34.094-.687.187-1.022.276s-.653.174-.978.264a1.608 1.608 0 0 1-.43.062 1.258 1.258 0 0 1-1.015-.532 97.53 97.53 0 0 0-1.436-1.775 3.337 3.337 0 0 0-5.208 0 79.395 79.395 0 0 0-1.413 1.748 1.278 1.278 0 0 1-1.045.556 1.732 1.732 0 0 1-.458-.068 49.872 49.872 0 0 0-2.337-.619 3.236 3.236 0 0 0-.727-.083 3.324 3.324 0 0 0-3.283 2.904c-.082.743-.109 1.507-.134 2.245l-.007.2a1.358 1.358 0 0 1-.974 1.362c-.509.178-1.022.379-1.517.573l-.481.188A3.339 3.339 0 0 0 .79 15.492c.41.638.81 1.262 1.21 1.854a1.277 1.277 0 0 1 0 1.519c-.411.619-.814 1.243-1.189 1.825a3.34 3.34 0 0 0 1.65 5.081l.538.21c.466.183.948.372 1.427.539a1.345 1.345 0 0 1 .974 1.361c.017.656.049 1.352.094 2.069a3.352 3.352 0 0 0 3.341 3.284 3.685 3.685 0 0 0 .887-.111c.65-.162 1.358-.354 2.166-.587a1.678 1.678 0 0 1 .461-.07 1.275 1.275 0 0 1 1.043.556l.227.292c.377.487.766.99 1.191 1.442a5.785 5.785 0 0 0 1.181.931 2.456 2.456 0 0 0 .642.243c.095.034.2.063.3.1zm.476-2.144a1.311 1.311 0 0 1-1-.546 82.165 82.165 0 0 1-.576-.714c-.273-.341-.554-.694-.841-1.032a3.28 3.28 0 0 0-2.563-1.276 3.978 3.978 0 0 0-.959.124c-.433.107-.871.226-1.294.341-.287.078-.584.159-.877.235a1.861 1.861 0 0 1-.464.064 1.164 1.164 0 0 1-1.182-1.148v-.091c-.019-.283-.032-.572-.045-.85-.028-.607-.057-1.234-.145-1.84a3.124 3.124 0 0 0-2.042-2.535 38.029 38.029 0 0 0-1.372-.534 61.4 61.4 0 0 1-.821-.312 1.309 1.309 0 0 1-.812-.782 1.292 1.292 0 0 1 .189-1.1c.183-.288.373-.578.556-.859.22-.336.447-.684.664-1.03a3.311 3.311 0 0 0 .007-3.765c-.241-.385-.495-.772-.74-1.146l-.445-.682a1.372 1.372 0 0 1-.233-1.17 1.353 1.353 0 0 1 .867-.8c.218-.084.437-.166.655-.249.474-.179.964-.364 1.438-.561a3.3 3.3 0 0 0 2.157-3.051c.022-.35.04-.707.059-1.052.021-.4.043-.821.07-1.231a1.164 1.164 0 0 1 1.172-1.154 1.463 1.463 0 0 1 .348.045c.356.09.717.188 1.066.282.4.107.8.217 1.209.318a4 4 0 0 0 .968.125A3.3 3.3 0 0 0 15 4.613c.275-.326.546-.665.808-.993.2-.248.4-.5.61-.754a1.191 1.191 0 0 1 1.978 0c.25.3.5.613.742.913.206.256.42.522.632.78A3.321 3.321 0 0 0 22.4 5.9a4.121 4.121 0 0 0 1-.132c.388-.1.781-.2 1.161-.307.342-.092.7-.187 1.045-.277a1.524 1.524 0 0 1 .38-.05A1.17 1.17 0 0 1 27.157 6.3v.023c.048.766.088 1.478.122 2.179a3.349 3.349 0 0 0 2.257 3.161c.384.154.777.3 1.158.445.308.116.627.236.939.358a1.306 1.306 0 0 1 .862 1.146v.025l-.01.023a5.241 5.241 0 0 0-.08.208 2.608 2.608 0 0 1-.211.47c-.264.428-.545.856-.816 1.269q-.176.267-.349.534a3.356 3.356 0 0 0-.008 3.912c.181.281.368.567.548.842.2.313.416.636.621.956a1.2 1.2 0 0 1-.613 1.908c-.688.27-1.393.538-2 .769a3.362 3.362 0 0 0-2.3 3.2 87.392 87.392 0 0 1-.125 2.215 1.174 1.174 0 0 1-1.173 1.138 1.363 1.363 0 0 1-.33-.042c-.37-.093-.745-.195-1.107-.293-.393-.107-.8-.217-1.2-.316a3.987 3.987 0 0 0-.954-.123 3.267 3.267 0 0 0-2.543 1.256c-.291.34-.576.7-.851 1.042-.192.24-.39.489-.59.73a1.307 1.307 0 0 1-1 .545m-4.984-3.769a3.472 3.472 0 0 1 2.716 1.347c.289.34.571.694.845 1.036.187.234.381.477.574.712a1 1 0 0 0 1.693 0c.2-.24.4-.488.588-.728.276-.346.562-.7.856-1.047a3.463 3.463 0 0 1 2.695-1.326 4.218 4.218 0 0 1 1 .129c.4.1.812.211 1.206.318.361.1.735.2 1.1.292a1.158 1.158 0 0 0 .281.036.967.967 0 0 0 .974-.952c.056-.825.1-1.548.124-2.21a3.551 3.551 0 0 1 2.428-3.374c.606-.23 1.311-.5 2-.768a1.006 1.006 0 0 0 .518-1.613c-.2-.319-.416-.642-.62-.954-.18-.276-.367-.561-.549-.843a3.541 3.541 0 0 1 .008-4.129q.174-.269.349-.535c.27-.412.55-.839.813-1.264a2.442 2.442 0 0 0 .193-.434c.023-.063.047-.128.073-.192a1.1 1.1 0 0 0-.733-.956 61.233 61.233 0 0 0-.937-.357c-.382-.144-.777-.292-1.162-.447a3.536 3.536 0 0 1-2.383-3.337c-.034-.7-.074-1.411-.122-2.176a.968.968 0 0 0-.935-1h-.04a1.367 1.367 0 0 0-.331.044c-.348.089-.7.185-1.043.277-.381.1-.775.209-1.164.307a4.28 4.28 0 0 1-1.05.138 3.51 3.51 0 0 1-2.782-1.416 80.669 80.669 0 0 1-.633-.782c-.241-.3-.491-.61-.74-.911a.993.993 0 0 0-1.67 0c-.2.248-.41.5-.608.752-.263.329-.535.669-.811 1a3.486 3.486 0 0 1-2.734 1.364 4.194 4.194 0 0 1-1.007-.131c-.406-.1-.816-.212-1.213-.319a71.246 71.246 0 0 0-1.063-.281 1.216 1.216 0 0 0-.3-.039.96.96 0 0 0-.972.948v.019c-.027.409-.049.826-.07 1.229-.018.345-.037.7-.059 1.053a3.487 3.487 0 0 1-2.278 3.223c-.477.2-.969.384-1.444.564l-.654.248a1.167 1.167 0 0 0-.749.676 1.179 1.179 0 0 0 .211 1q.22.341.444.68c.246.375.5.762.742 1.149a3.5 3.5 0 0 1-.007 3.977c-.218.347-.446.7-.666 1.033-.183.28-.372.57-.555.857a1.082 1.082 0 0 0-.167.927 1.113 1.113 0 0 0 .694.658c.272.106.549.21.818.311.454.17.923.346 1.379.537a3.353 3.353 0 0 1 2.163 2.69c.09.616.119 1.248.147 1.86.013.278.026.565.045.846.044.669.4 1.052.98 1.052a1.645 1.645 0 0 0 .413-.057c.292-.076.588-.157.875-.234.425-.115.864-.235 1.3-.342a4.2 4.2 0 0 1 1.011-.132z",
    style: {
      fill: "url(#dgzhaofw9b)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2938"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2937",
    style: {
      clipPath: "url(#oyunxhwfkf)"
    },
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5831",
    transform: "translate(10.345 11.83)",
    style: {
      fill: "#6f6f6f"
    },
    d: "M0 0h13.25v13.225H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2940"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2939",
    style: {
      clipPath: "url(#7qevs4so2e)"
    },
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4137",
    d: "M11.512 25.145a1.265 1.265 0 0 1-1.264-1.245 1.272 1.272 0 0 1 .263-.79 1.872 1.872 0 0 1 .2-.218q5.349-5.351 10.7-10.707a1.28 1.28 0 0 1 1.36-.4 1.243 1.243 0 0 1 .9 1.276 1.283 1.283 0 0 1-.447.914q-1.167 1.161-2.338 2.337l-8.338 8.34a1.394 1.394 0 0 1-1.006.492zM22.391 11.93a1.088 1.088 0 0 0-.836.393Q16.2 17.688 10.849 23.039a1.742 1.742 0 0 0-.18.2 1.063 1.063 0 0 0 .859 1.71 1.2 1.2 0 0 0 .863-.427l8.344-8.346Q21.9 15 23.08 13.829a1.089 1.089 0 0 0 .382-.776 1.045 1.045 0 0 0-.752-1.074 1.13 1.13 0 0 0-.319-.047",
    style: {
      fill: "url(#dgzhaofw9b)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2942"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2941",
    style: {
      clipPath: "url(#uxbw249ffg)"
    },
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5833",
    transform: "translate(10.309 11.83)",
    style: {
      fill: "#666"
    },
    d: "M0 0h4.681v4.681H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2944"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2943",
    style: {
      clipPath: "url(#7qevs4so2e)"
    },
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4139",
    d: "M12.643 16.6a2.434 2.434 0 0 1-2.434-2.414v-.088a2.435 2.435 0 1 1 2.455 2.5zm-2.233-2.5v.08a2.233 2.233 0 0 0 2.233 2.22h.02a2.235 2.235 0 0 0 .043-4.469 2.175 2.175 0 0 0-1.6.61 2.227 2.227 0 0 0-.7 1.562",
    style: {
      fill: "url(#dgzhaofw9b)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2946"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2945",
    style: {
      clipPath: "url(#km0tfhhmqh)"
    },
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5835",
    transform: "translate(18.945 20.427)",
    style: {
      fill: "gray"
    },
    d: "M0 0h4.66v4.654H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2948"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2947",
    style: {
      clipPath: "url(#7qevs4so2e)"
    },
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4141",
    d: "M21.288 25.181h-.02a2.427 2.427 0 0 1 .006-4.854h.007a2.427 2.427 0 0 1 .007 4.854m-.018-.2h.018a2.227 2.227 0 0 0-.007-4.454h-.007a2.227 2.227 0 0 0 0 4.454",
    style: {
      fill: "url(#dgzhaofw9b)"
    }
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcHomeDiscount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-homeDiscount.24ae912dbaefe2df031235c68f31accc.svg";